<template>
  <div class="comment-tem-commentbox">
    <div class="comment-tem-left">
      <div class="articletx">
        <img @click="gotootherdynamic" :data-otherrenid="item.api_uid" :src="item.avatar_url" />
      </div>
    </div>
    <div class="comment-tem-right">
      <div class="article-r-top">
        <div class="article-title" @click="gotootherdynamic" :data-otherrenid="item.api_uid">
          <div class="article-author">{{item.name}}</div>
        </div>
      </div>
      <div class="article-content">
        <div
          class="article-content-text"
          @click="upCommentbigchild"
          :data-toname="item.name"
          :data-uid="item.api_uid"
          :data-cid="item.id"
          :data-name="item.name"
          id="article-content-text"
        >{{item.content}}</div>

        <div class="comment-imgbox" v-if="item.content_extra.length>0">
          <div class="comment-imgbox-nr">
            <img
              :src="item.content_extra"
              @click="showImg"
              :data-imgurl="item.content_extra"
              data-imgidx="0"
              mode="widthFix"
            />
          </div>
        </div>
      </div>
      <div class="article-echo">
        <div class="comment-tem-dianping">
          <div
            class="article-echo-cell comment-tem-applause"
            @click="dianzanbtn"
            :data-cid="item.id"
          >
            <div v-if="item.is_nice == 1">
              <span class="red">{{item.nices_num}}</span>
              <img src="../../assets/images/dynamic_btn_praise_selected.png" />
            </div>
            <div v-else>
              <span v-if="item.nices_num>0">{{item.nices_num}}</span>
              <img src="../../assets/images/dynamic_btn_praise_normal.png" />
            </div>
          </div>
          <div
            @click="upCommentbigchild"
            :data-toname="item.name"
            :data-uid="item.api_uid"
            :data-cid="item.id"
            :data-name="item.name"
            class="article-echo-cell comment-tem-comment"
          >
            <img src="../../assets/images/dynamic_icon_comment.png" />
          </div>
        </div>

        <div class="comment-tem-time">{{item.ctime}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getnicecomment } from "../../api/api";
import Vue from "vue";
import { ImagePreview, Toast } from "vant";

Vue.use(ImagePreview);
Vue.use(Toast);
export default {
  props: ["item", "index", "commentList"],
  name: "comment",
  data() {
    return {};
  },
  methods: {
    gotootherdynamic: function(e) {
      let otherrenid = e.currentTarget.dataset.otherrenid;
      this.$router.push({
        name:'dynamic',
        query:{
          otherrenid:otherrenid
        }
      })
    },
    upCommentbigchild: function(e) {
      this.$emit("upCommentbig", e);
    },
    //点赞和取消点赞
    gooddianzan: function(item_id) {
      var that = this;
      var show; //传递到数据库点赞的状态
      var cookie_mid = this.$store.getters.getDtDzShu || []; //获取全部点赞的mid
      var newmessage = [];

      for (var i = 0; i < that.commentList.length; i++) {
        if (that.commentList[i].id == item_id) {
          //遍历找到对应的id

          var num = that.commentList[i].nices_num; //当前赞数
          var isnice = that.commentList[i].is_nice;
          var isshow; //点赞的状态

          if (cookie_mid.includes(item_id) || isnice == 1) {
            //说明已经点过赞,取消赞
            for (var j = 0; j < cookie_mid.length; j++) {
              if (cookie_mid[j] == item_id) {
                cookie_mid.splice(j, 1); //删除取消赞的mid
              }
            }
            --num;
            isshow = 0; //点赞的状态
            that.commentList[i].nices_num = num;
            that.commentList[i].is_nice = isshow;
            that.$store.dispatch("changeDtDzShuFun", cookie_mid);
          } else {
            isshow = 1; //点赞的状态
            ++num;

            that.commentList[i].nices_num = num;
            that.commentList[i].is_nice = isshow;
            cookie_mid.unshift(item_id); //新增赞的mid
            that.$store.dispatch("changeDtDzShuFun", cookie_mid);
          }

          getnicecomment(item_id).then(res => {
            if (res.code != 200) {
              Toast.fail({
                message: "数据错误!",
                duration: 2000
              });
            }
          });
        }
      }
    },
    dianzanbtn: function(e) {
      var item_id = e.currentTarget.dataset.cid; //此处找到列表的id
      this.gooddianzan(item_id);
    },
    showImg: function(e) {
      ImagePreview({
        images: [e.currentTarget.dataset.imgurl]
      });
    }
  }
};
</script>

<style scoped>
.comment-tem-commentbox {
  display: flex;
  flex-flow: row nowrap;
  border-bottom: 0.02702702702702703rem solid #f8f8f8;
  padding-bottom: 0.8108108108108109rem;
}
.comment-tem-commentbox .comment-tem-left {
  width: 3.135135135135135rem;
  flex: 0 0 3.135135135135135rem;
}
.comment-tem-commentbox .comment-tem-left .articletx {
  padding-top: 0.9459459459459459rem;
  width: 1.7837837837837838rem;
  height: 1.7837837837837838rem;
  border-radius: 50%;
  margin: 0 auto;
}
.comment-tem-commentbox .comment-tem-left .articletx img {
  width: 1.7837837837837838rem;
  height: 1.7837837837837838rem;
  border-radius: 50%;
}
.comment-tem-commentbox .comment-tem-right {
  width: 17.135135135135137rem;
  flex: 0 0 17.135135135135137rem;
  padding-right: 0.6756756756756757rem;
}
.comment-tem-commentbox .comment-tem-right .article-r-top {
  padding-top: 0.8108108108108109rem;
}
.comment-tem-commentbox .comment-tem-right .article-r-top .article-title {
}
.comment-tem-commentbox
  .comment-tem-right
  .article-r-top
  .article-title
  .article-author {
  font-size: 0.7567567567567568rem;
  color: #333;
  font-weight: bold;
}
.comment-tem-commentbox
  .comment-tem-right
  .article-r-top
  .article-title
  .article-time {
  padding-top: 0.13513513513513514rem;
  color: #999;
}
.comment-tem-commentbox .comment-tem-right .article-r-top .followbtn {
  float: right;
  padding-top: 0.13513513513513514rem;
}
.comment-tem-commentbox .comment-tem-right .article-r-top .followbtn button {
  width: 3.5135135135135136rem;
  font-size: 0.7027027027027027rem;
  height: 1.4324324324324325rem;
  background: #fff;
  border: 1px solid #ffbd0a;
  line-height: 1.3513513513513513rem;
  color: #ffbd0a;
}
.comment-tem-commentbox .comment-tem-right .article-content {
  padding-top: 0.2702702702702703rem;
  position: relative;
}
.comment-tem-commentbox
  .comment-tem-right
  .article-content
  .article-content-text {
  color: #4c4c4c;
  font-size: 0.7567567567567568rem;
  white-space: wrap;
  text-overflow: ellipsis;
  line-height: 1.2432432432432432rem;
  word-break: break-all;
}
.comment-tem-commentbox .comment-tem-right .article-content .comment-imgbox {
  padding-top: 0.6756756756756757rem;
}
.comment-tem-commentbox
  .comment-tem-right
  .article-content
  .comment-imgbox
  .comment-imgbox-nr {
  width: 7.5675675675675675rem;
}
.comment-tem-commentbox
  .comment-tem-right
  .article-content
  .comment-imgbox
  .comment-imgbox-nr
  img {
  max-width: 7.5675675675675675rem;
}
.comment-tem-commentbox .comment-tem-right .article-echo {
  padding-top: 0.2702702702702703rem;
  padding-right: 0.875676rem;
}
.comment-tem-commentbox .comment-tem-right .article-echo .article-echo-cell {
  padding-left: 1.0810810810810811rem;
}
.comment-tem-commentbox .comment-tem-right .article-echo .comment-tem-dianping {
  float: right;
}
.comment-tem-commentbox
  .comment-tem-right
  .article-echo
  .comment-tem-dianping
  .comment-tem-comment {
  float: left;
}
.comment-tem-commentbox
  .comment-tem-right
  .article-echo
  .comment-tem-dianping
  .comment-tem-applause {
  float: left;
}
.comment-tem-commentbox
  .comment-tem-right
  .article-echo
  .comment-tem-dianping
  .comment-tem-applause
  span {
  padding-right: 0.21621621621621623rem;
  padding-top: 0.08108108108108109rem;
}
.comment-tem-commentbox
  .comment-tem-right
  .article-echo
  .article-echo-cell
  img {
  width: 0.8108108108108109rem;
  height: 0.8108108108108109rem;
  float: left;
  margin-top: 0.10810810810810811rem;
}
.comment-tem-commentbox
  .comment-tem-right
  .article-echo
  .article-echo-cell
  span {
  float: left;
  padding-left: 0.40540540540540543rem;
  font-size: 0.7567567567567568rem;
  color: #333;
}
.comment-tem-commentbox
  .comment-tem-right
  .article-echo
  .article-echo-cell
  span.red {
  color: #f5495a;
}
.comment-tem-commentbox
  .comment-tem-right
  .article-echo
  .comment-tem-comment
  img {
  width: 0.8918918918918919rem;
  height: 0.8648648648648649rem;
  float: left;
}
.comment-tem-commentbox .comment-tem-right .article-echo .comment-tem-time {
  font-size: 0.7567567567567568rem;
  color: #999;
}
</style>


// WEBPACK FOOTER //
// src/components/public/comment.vue